var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
export var applyLogoThumbnailSize = function (size) {
  return function (entity) {
    var _a, _b;
    var logo = ((_b = (_a = entity === null || entity === void 0 ? void 0 : entity.logo) === null || _a === void 0 ? void 0 : _a.thumbnails) === null || _b === void 0 ? void 0 : _b[size]) || entity.logo;
    return __assign(__assign({}, entity), {
      logo: logo
    });
  };
};